<template>
  <div class="content">
    <fundraise-menu>
      <template slot="title">
        <div>Impact Amounts</div>
        <p>Display giving amounts that show the impact a donation has on your cause</p>
      </template>
    </fundraise-menu>

    <div class="flex flex-wrap overflow-hidden px-8 md:px-4 pt-4 settings-body impact-content">
      <div class="w-4/5 xl:w-4/6 lg:w-full pr-5 lg:pr-0 ">
        <div class="s-block shadow-md">
            <div class="s-block-header">Donation Impact Amounts</div>
            <div class="s-block-body sbd-fundraise">
              <table class="table table-form" style="table-layout: auto;">
                <tr>
                  <th style="width: 55px">Image</th>
                  <th style="width: 120px">Amount</th>
                  <th>Title</th>
                  <th style="width: 50%">Description</th>
                  <th style="width: 30px"></th>
                </tr>
                <tr v-for="(impact, index) in impactAmounts"
                    :key="impact.id"
                >
                  <td style="width: 55px">
                    <input type="hidden" v-model="impact.id">
                    <input type="file"
                           class="hidden"
                           :id="`uploadImg${index}`"
                           accept="image/*"
                           @change="onImageChange(index, $event)">

                    <div v-if="impact.isLogoUploading"
                         class="choose-template-loading">
                      <div class="spinner-wrap">
                        <font-awesome-icon class="text-primary" spin :icon="['fas', 'spinner']"/>
                      </div>
                    </div>
                    <div v-else
                         class="img-preview"
                         v-on:click.prevent="openUpload(index)"
                    >
                      <img v-if="impact.image"
                           :src="impact.image">
                    </div>
                  </td>
                  <td style="position: relative">
                    <span class="currency-icon">$</span>
                    <input type="text"
                           class="form-control relative"
                           placeholder="100"
                           style="padding-left: 27px;"
                           v-model="impact.amount">
                  </td>
                  <td>
                    <input type="text"
                           class="form-control"
                           placeholder="Title"
                           v-model="impact.name"
                    >
                  </td>
                  <td>
                    <input type="text"
                           class="form-control"
                           placeholder="Description"
                           v-model="impact.description"
                    >
                  </td>
                  <td class="text-right">
                    <a href="#"
                       v-on:click.prevent="deleteImpactAmount(impact.id, index)"
                    >
                      <font-awesome-icon :icon="['fas', 'trash-alt']"/>
                    </a>
                  </td>
                </tr>
                <tr>
                  <td colspan="2" class="btn-wrap">
                    <div class="btn-wrap">
                      <a class="btn btn-sm"
                         href="#"
                         v-on:click.prevent="addImpactAmount"
                         style="margin-left: 0; padding: 11px 12px;">+ Add</a></div>
                  </td>
                  <td></td>
                  <td colspan="2" class="text-right">
                    <div class="btn-wrap">
                      <a class="btn btn-sm btn-preview"
                         target="_blank"
                         v-if="activeCharityInfo"
                         :href="'/impact-amounts' | webAppLink(activeCharityInfo)"
                      >Preview</a></div>
                  </td>
                </tr>
              </table>

            </div>
          </div>
      </div>
      <div class="w-1/5 xl:w-2/6 lg:w-full">
        <div class="d-block shadow-md left-sidebar relative">
          <div class="faq-list rounded-t-md">
            <div>
              <h2><a href="http://help.harnessapp.com/en/articles/4489098-what-are-impact-amounts" target="_blank" class="text-black">What are Impact Amounts?</a></h2>
              <p class="info">They are donation amounts that allow you to show the impact a donation has on your cause ($30 = 10 warm meals)</p>
            </div>

          </div>
          <ul>
            <li>
              <a href="http://help.harnessapp.com/en/articles/4489098-what-are-impact-amounts" target="_blank" class="visit">IMPACT PAGES</a>
            </li>
            <li>
              <a :href="`${config.donor_next_scheme}://${activeCharityInfo.subdomain}.${config.donor_next_url}/impact-amounts`" target="_blank">Impact Amounts</a>
            </li>
            <li>
              <a :href="`${config.donor_next_scheme}://${activeCharityInfo.subdomain}.${config.donor_next_url}/donation-calculator`" target="_blank">Donation Calculator</a>
            </li>
            <li>
              <a :href="`${config.donor_next_scheme}://${activeCharityInfo.subdomain}.${config.donor_next_url}/impact-calculator`" target="_blank">Impact Calculator</a>
            </li>
            <li>
              <a href="http://help.harnessapp.com/en/articles/4489098-what-are-impact-amounts" target="_blank" class="visit">Learn More</a>
            </li>
          </ul>
        </div>
      </div>



      <div v-if="isEdited" class="settings-btn-bottom">
        <div class="row">
          <div class="col-md-12">
            <div class="text-right btn-wrap">
              <a href="#" v-on:click.prevent="resetEdit"
                 class="btn btn-sm btn-cancel">Cancel</a>

              <a v-if="isAllowSave"
                 href="#"
                 v-on:click.prevent="saveData"
                 class="btn btn-sm">Save Changes</a>
              <a v-else
                 href="#"
                 v-on:click.stop.prevent=""
                 style="pointer-events: auto;"
                 v-tippy
                 content="Please include an Amount and Title for each of your Impact Amounts"
                 class="disabled btn btn-sm">Save Changes</a>

            </div>

          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import FundraiseMenu from './menu.vue';
  import {ImpactAmounts, globalImageUploader} from '@/utils/api';
  import config from '../../../public/harness_config.json';
  import {mapState} from "vuex";

  export default {
    name: 'ImpactAmounts',

    metaInfo: {
      title: 'Fundraise - Impact Amounts',
    },
    components: {
      FundraiseMenu,
    },
    mounted() {
      this.updateImpactAmounts();
    },
    methods: {
      openUpload(index) {
        document.getElementById(`uploadImg${index}`).click()
      },
      onImageChange(index, e) {
        const file = e.target.files[0];
        if (file && file.type.substr(0, 5) === 'image') {
          this.impactAmounts[index].image = false
          this.impactAmounts[index].isLogoUploading = true
          globalImageUploader(file)
            .then((result) => {
              this.impactAmounts[index].isLogoUploading = false
              if (result) {
                this.impactAmounts[index].image = result;
              } else {
                alert('image post error');
              }
            })
            .catch(() => alert('image post error'))
            .finally(() => this.impactAmounts[index].isLogoUploading = false);
        }
      },
      fixAmounts(impactAmounts, r = .01) {
        return impactAmounts.map(i => (
          {
            ...i, 
            // See: `safeRound` in donation-asks.vue for additional info
            amount: ((r < 1) ? (i.amount * r).toFixed(2) : Math.round(i.amount * r)) + ''
          }
        ))
      },
      updateImpactAmounts() {
        ImpactAmounts.getImpactAmounts(this.activeCharityId)
          .then(impactAmounts => {

            this.impactAmounts = this.fixAmounts(JSON.parse(JSON.stringify(impactAmounts)));
            this.initImpactAmounts = this.fixAmounts(JSON.parse(JSON.stringify(impactAmounts)));
            if(this.impactAmounts.length === 0 ){
              this.addImpactAmount();
            }

            this.isSaving = false;
          });
      },
      addImpactAmount() {
        this.impactAmounts.push({...this.emptyImpactAmount});
      },
      deleteImpactAmount(id, indexNumber) {
        if (id) {
          //real delete
          ImpactAmounts.delete(id, this.activeCharityId)
            .then(() => {
              this.impactAmounts.splice(indexNumber, 1);
              this.$message('Impact Amount deleted');
            }).catch(err => alert(err.error));
        } else {
          //delete unsaved row
          this.impactAmounts.splice(indexNumber, 1);
        }
      },
      resetEdit() {
        this.impactAmounts = JSON.parse(JSON.stringify(this.initImpactAmounts));
      },
      saveData() {
        const impactAmounts = this.fixAmounts(this.allRows, 100)

        const promises = [];
        this.isSaving = true;

        for (let i = 0; i < impactAmounts.length; i++) {
          if (impactAmounts[i].id) {
            //update if required

            const initialImpactAmount = JSON.parse(JSON.stringify(this.initImpactAmounts))
              .find(t => String(t.id) === String(impactAmounts[i].id))

            initialImpactAmount.amount = String(initialImpactAmount.amount * 100);


            if (JSON.stringify(impactAmounts[i]) !== JSON.stringify(initialImpactAmount)) {
              promises.push(ImpactAmounts.update(
                impactAmounts[i].id,
                impactAmounts[i].name,
                impactAmounts[i].description,
                impactAmounts[i].amount,
                impactAmounts[i].image,
                this.activeCharityId
              ));
            }


          } else {
            //create
            promises.push(ImpactAmounts.create(
              impactAmounts[i].name,
              impactAmounts[i].description,
              impactAmounts[i].amount,
              impactAmounts[i].image,
              this.activeCharityId
            ));
          }
        }
        Promise.all(promises).then(() => {
          this.$message('Impact Amounts updated');
          this.updateImpactAmounts();
        }).catch(() => this.isSaving = false);
      }
    },
    computed: {
      ...mapState({
        activeCharityId: state => state.auth.activeCharityId,
        activeCharityInfo: state => state.charities.activeCharityInfo,
      }),
      isAllowSave() {
        return this.allRows.filter(i => Number(i.amount) === 0 || i.name === '').length === 0;
      },
      config() {
        return config;
      },
      allRows() {
        return JSON.parse(JSON.stringify(this.impactAmounts))
          .filter(i => i.id || i.name || i.description || i.image || i.amount);
      },
      isEdited() {
        if (this.isSaving) {
          return false;
        }
        if (this.impactAmounts.length) {
          const impactAmounts = this.impactAmounts
            .filter(i => i.id || i.name || i.description || i.image || i.amount)

          return JSON.stringify(impactAmounts) !== JSON.stringify(this.initImpactAmounts);
        }

        return false
      }
    },
    watch: {
      'activeCharityId'() {
        this.updateImpactAmounts();
      },
    },
    data() {
      return {
        isSaving: false,
        impactAmounts: [],
        initImpactAmounts: [],
        emptyImpactAmount: {
          "id": null,
          "name": '',
          "description": '',
          "image": null,
          "amount": ''
        }
      };
    },
  };
</script>
<style lang="scss">
  .s-block .s-block-body.sbd-fundraise {
    padding: 10px 25px 25px;
  }

  .table.table-form {
    .img-preview {
      display: block;
      cursor: pointer;
      border-radius: 4px;
      width: 55px;
      height: 36px;
      background: url("../../assets/images/fallback-thumbnail.png") center no-repeat;
      background-size: 100% auto;
      background-color: #dfe3e9;

      img {
        display: block;
        width: 100%;
        max-width: 100%;
        height: 100%;
        object-fit: contain;
        border-radius: 4px;
        background-color: #ffffff;
      }
    }

    th {
      text-align: left;
      font-weight: 600;
      border: none;
      padding: 0 7.5px;
      color: #050926;
    }

    td {
      padding: 7.5px;
    }

    th, td {
      border: none;

      &:first-of-type {
        padding-left: 0;
        text-align: left;
      }

      &:last-of-type {
        padding-right: 0;
      }
    }

    tr:last-of-type {
      td {
        padding-top: 2.5px;
      }
    }
    .currency-icon {
      position: absolute;
      z-index: 1000;
      display: inline-block;
      width: 23px;
      height: 36px;
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
      line-height: 34px;
      text-align: center;
      border: solid 1px #dfe3e9;
      background-color: #dfe3e9;
    }
  }

  .relative {
    position: relative;
  }
</style>
<style lang="scss" scoped>
  .spinner-wrap {
    display: none;
  }
  .visit {
    font-weight: 700 !important;
  }

  .choose-template-loading {
    border-radius: 4px;
    width: 55px;
    height: 36px;
    border: 1px solid #dfe3e9;
    background-color: #ffffff;
    position: relative;
    overflow: hidden;

    .spinner-wrap {
      display: block;
      text-align: center;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      padding-top: 6px;
      background-color: rgba(255, 255, 255, 0.7);
    }
  }
</style>
